module.exports = __webpack_public_path__ + "img/border_right_arrow.a0d4da92.svg";